"use strict";
var wall = document.querySelector(".wall");
var spider = document.querySelector(".spider");
document.addEventListener("click", function(e) {
    var wallSizes = wall.getBoundingClientRect();
    var spSizes = spider.getBoundingClientRect();
    var left = e.clientX - wallSizes.left - wall.clientLeft - spSizes.width / 2;
    var up = e.clientY - wallSizes.top - wall.clientTop - spSizes.height / 2;
    var maxLeft = wall.clientWidth - spSizes.width;
    var maxUp = wall.clientHeight - spSizes.height;
    var boundX = Math.min(Math.max(0, left), maxLeft);
    var boundY = Math.min(Math.max(0, up), maxUp);
    if (e.clientX < wallSizes.left || e.clientX > wallSizes.right || e.clientY < wallSizes.top || e.clientY > wallSizes.bottom) return;
    spider.style.left = "".concat(boundX, "px");
    spider.style.top = "".concat(boundY, "px");
});

//# sourceMappingURL=index.2737dbbd.js.map
